import React, { useState } from "react";
import { Link } from "react-router-dom";


const Button = ({ type, style, btnName, className, link }) => {

  
  return (
    <>
      <button type={type}  style={style} className={className} 
        >
        
      <Link to={link}>{btnName}</Link>
      </button>
    </>
  );
};

export default Button;
